module.exports = __webpack_public_path__ + "img/zcyfour.172f7be8.png";